<template>
    <mobile-panel-wrapper
        :is-open="isOpen" element-height="250px"
        class="items-center" :class="hasClearedIntro && 'opacity-0'">
        <div class="absolute bottom-0 left-0 right-0 h-[376px] bg-gray-100 p-4 flex flex-col flex-1 pointer-events-none">
            <div class="flex items-center mb-2 w-full flex-col justify-center">
                <div class="text-2xl md:text-3xl uppercase font-extrabold text-center">
                    {{viewController?.blueprint?.name}}
                </div>
            </div>
            <div class="text-sm mb-2 text-center">
                {{defaultUnitPriceFormatted}} {{$t('PRICE_EACH')}}
            </div>
            <div class="flex flex-col items-center space-y-1 flex-1 pointer-events-auto">
                <div class="text-stone-800 mb-2">
                    Are you customizing for an individual or a group?
                </div>
                <div class="flex mb-2">
                    <input
                        type="radio"
                        name="individual"
                        id="individual"
                        class="mr-2 text-green-500"
                        v-model="group"
                        value="individual"
                    />
                    <label for="individual" class="text-stone-800">Standard Customization</label>
                </div>
                <div class="flex mb-2">
                    <input
                        type="radio"
                        name="group"
                        id="group"
                        class="mr-2"
                        v-model="group"
                        value="group"
                    />
                    <label for="group" class="text-stone-800 mr-4">Group Personalization</label>
                </div>
                <p class="max-w-sm">With Group Personalization, you can customize the names and/or numbers on indidvidual bottles with the same design.</p>
                <div class="flex flex-col flex-1" />
                <div
                    class="flex w-full justify-center max-w-md pointer-events-auto">
                    <primary-button @click="handleSelectStep">
                        {{ $t('GET_STARTED') }}
                    </primary-button>
                </div>
            </div>
        </div>
    </mobile-panel-wrapper>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import MobilePanelWrapper from './MobilePanelWrapper.vue';
    import PrimaryButton from '../../buttons/PrimaryButton.vue';

    export default {
        components: { MobilePanelWrapper, PrimaryButton },
        data() {
            return {
                group: 'individual',
            };
        },
        props: {
            hasClearedIntro: {
                type: Boolean,
                default: false,
            },
            isOpen: {
                type: Boolean,
                default: false,
            },
            setPanel: {
                type: Function,
                default: () => {},
            },
            elementHeight: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapState({
                selectedStep: ({ selectedStep }) => selectedStep,

                viewController: ({ customizer }) => customizer.viewController,
            }),

            defaultUnitPriceFormatted() {
                return this.$store.getters.defaultUnitPriceFormatted;
            },
        },

        methods: {
            ...mapActions([
                'selectStep',
            ]),

            handleSelectStep() {
                this.$store.dispatch('setIsGroupOrder', this.group === 'group');
                this.$emit('clear-intro');
            },
        },
    };
</script>
